import { render, staticRenderFns } from "./xskUploadAudio.vue?vue&type=template&id=4b42bbec"
import script from "./xskUploadAudio.vue?vue&type=script&lang=js"
export * from "./xskUploadAudio.vue?vue&type=script&lang=js"
import style0 from "./xskUploadAudio.vue?vue&type=style&index=0&id=4b42bbec&prod&lang=css"
import style1 from "./xskUploadAudio.vue?vue&type=style&index=1&id=4b42bbec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports